import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import ChannelActions from './channel-actions';

const initialState = Immutable({ byId: {}, isFetching: false, hasFetched: false });

const reducer = createReducer(on => {
  on(ChannelActions.fetch, state => state.set('isFetching', true));
  on(ChannelActions.fetchFailure, state => state.set('isFetching', false));
  on(ChannelActions.fetchSuccess, (state, { channels }) => {
    const byId = _.reduce(
      channels,
      (acc, channel) => {
        acc[channel.id] = channel;
        return acc;
      },
      {}
    );
    return state.merge({ isFetching: false, hasFetched: true, byId });
  });

  on(ChannelActions.removeChannel, (state, { id }) => state.set('byId', _.omit(state.byId, id)));

  on(ChannelActions.updateChannel, (state, { channelId, update }) => {
    return state.setIn(['byId', channelId, update.id], update.value);
  });

  on(ChannelActions.resetChannel, (state, { channel }) => state.setIn(['byId', channel.id], channel));

  on(ChannelActions.saveChannel, (state, { channel }) => state.setIn(['byId', channel.id], channel));

  on(ChannelActions.deauthChannelSuccess, (state, { channel }) => state.setIn(['byId', channel.id], channel));

  on(ChannelActions.deleteChannelSuccess, (state, { channelId }) => state.set('byId', _.omit(state.byId, channelId)));

  on(ChannelActions.saveChannelSuccess, (state, { channel }) => {
    const channels = _.isArray(channel) ? channel : [channel];
    let channelsById = _.reduce(
      channels,
      (acc, channel) => {
        acc[channel.id] = channel;
        return acc;
      },
      {}
    );
    channelsById = state.byId.merge(channelsById);
    return state.set('byId', channelsById);
  });

  on(ChannelActions.add, (state, { channels }) => {
    let channelsById = _.reduce(
      channels,
      (acc, channel) => {
        acc[channel.id] = channel;
        return acc;
      },
      {}
    );
    channelsById = state.byId.merge(channelsById);
    return state.set('byId', channelsById);
  });
}, initialState);

export default reducer;
